window.AudioContext = window.AudioContext || window.webkitAudioContext;

const MAX_BEEPS = 7;
export default () => {
	const context = new AudioContext();

	return {
		setup() {
			const oscillator = context.createOscillator();
			const gain = context.createGain();
			oscillator.connect(gain);
			gain.connect(context.destination);
			oscillator.type = 'sine';
			return { oscillator, gain };
		},
		play(value, count = 0) {
			if (count > MAX_BEEPS) {
				return;
			}
			const { oscillator, gain } = this.setup();
			oscillator.frequency.value = value;
			gain.gain.value = 0.5;

			oscillator.start(context.currentTime);
			this.stop({ oscillator, gain });
			const newValue = (count % 3 > 0 ? value + 100 : value - 100);
			setTimeout(() => this.play(newValue, count + 1), 100);
		},
		stop({ oscillator, gain }) {
			const totalPlayTime = 0.1;
			gain.gain.exponentialRampToValueAtTime(0.001, context.currentTime + totalPlayTime);
			oscillator.stop(context.currentTime + totalPlayTime);
		},
	};
};



// WEBPACK FOOTER //
// ./src/components/Beeper.js